const Config = require("../lib/config");
export default {
  Address: Config.ContractAddress,
  contractObj: {},
  ABI: Config.ContractABI,
};
